module.exports = __webpack_public_path__ + "static/media/18ECA19.3a701692.jpg";